module.exports = __webpack_public_path__ + "img/play.7f452ae2.png";